/**
 * Created by Administrador on 31/10/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('luggageManifestCtrl', luggageManifestCtrl);

    luggageManifestCtrl.$inject = ['$stateParams', 'tabs', 'datePickerService', 'airports', 'flightService',
        'linkService','reportService'];

    function luggageManifestCtrl($stateParams, tabs, datePickerService, airports, flightService, linkService, reportService){
        var vm = this;

        vm.tabs = tabs;
        vm.airports = airports;
        vm.flights = [];
        vm.report = undefined;
        vm.departureDate = new Date();

        vm.dateParam = $stateParams.date;
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.eventChangeOrigin = function(){
            vm.report = undefined;
            if(vm.departureDate != undefined && vm.originAirport != undefined){
                vm.flights= [];
                flightService.getFlightByDepartureDateAndOrigin(vm.departureDate.getTime(),linkService.getLinkId(vm.originAirport._links.self.href))
                    .then(function (response) {
                        angular.forEach(response, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                departureFlightId: linkService.getLinkId(flight._embedded.departureflights[0]._links.self.href),
                                route: flight._embedded.route.initials,
                                departureFlightOrder: flight._embedded.departureflights[0].order,
                                flightId: linkService.getLinkId(flight._links.self.href)
                            });
                        });
                    });
            }
        }

        vm.eventChangeFlight = function(){
            vm.report = undefined;
            if(vm.flight != undefined){
                reportService.getGeneralManifest(vm.flight.departureFlightId,'luggage',vm.flight.flightId,vm.flight.departureFlightOrder,'pnr')
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }

        vm.exportPdf = function(reducedPrint){
            reportService.getLuggageManifestPdf(vm.flight.departureFlightId,reducedPrint)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "luggage_manifest_"+(reducedPrint?"r":"n")+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }
    }
})();
